//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';

import InstagramPostUploader from '@instagram-post-uploader/components/InstagramPostUploader';
import makeAngularReactController from '@react-bridge/angular-react-widget';

angular.module('curalate').component('instagramPostUploaderModal', {
  controller: makeAngularReactController(<InstagramPostUploader/>),
});
